import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Orange_Btn.css'

const Orange_Btn = (props) => {
    return (
        <button className="Orange_Btn" onClick={props?.onClick} type='button'>
            {props?.icon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={props?.icon} className='lefticon'/>
                </div>
            )}
            <p className='btn_text'>{props?.btnText}</p>
        </button>
    )
}

export default Orange_Btn
